import type { RouteRecordRaw } from 'vue-router'

const studentsRouteNames = {
  studentProfile: 'studentProfile',
  studentProfileAnalysis: 'studentProfileAnalysis',
  studentProfileComparison: 'studentProfileComparison'
}

const studentsRoutes: RouteRecordRaw[] = [
  {
    path: 'profile/:id',
    name: studentsRouteNames.studentProfile,
    meta: { notRenderInSidebar: true },
    component: () => import('@/features/students/StudentProfile.vue')
  },
  {
    path: 'profile/:id/comparison',
    name: studentsRouteNames.studentProfileComparison,
    meta: {
      parentName: studentsRouteNames.studentProfile,
      notRenderInSidebar: true
    },
    component: () => import('@/features/students/StudentProfileComparison.vue')
  },
  {
    path: 'profile/:id/analysis',
    name: studentsRouteNames.studentProfileAnalysis,
    meta: {
      parentName: studentsRouteNames.studentProfile,
      notRenderInSidebar: true
    },
    component: () => import('@/features/students/StudentProfileAnalysis.vue')
  }
]

export {
  studentsRouteNames,
  studentsRoutes
}
